import { ItemPlace } from "src/app/site/shared-components/item-location-overlay/models/model";

export class GetBranches {
    static readonly type = '[Branch] Get Branches';
    constructor(public place: ItemPlace) { }
}

export class SetSelectedBranch {
    static readonly type = '[Branch] Set Selected Branch';
    constructor(public branchId: number) {}
  }
  